import Skeleton from "@mui/material/Skeleton";
export default Skeleton;
export * from "@mui/material/Skeleton";